import React, {useEffect, useState} from 'react';
import {MainTable} from './../../../Components/Macro/MainTable/MainTable'
import {useBooks} from './BookStore';
import Add from './Add';
import Edit from './Edit';

function Books() {
    let [rend, setRend] = useState(true)
    let {books, columns, getBooks, deleteItem, setEd} = useBooks()

    useEffect(() => {
        getBooks()
    }, [])

    return (
        <>
            <MainTable
                pageTitle={"Kitoblar"}
                pcolumns={columns}
                pdata={books}
                defkey={'id'}
                add={<Add rend={rend} setR={setRend}/>}
                onDelete={deleteItem}
                edit={<Edit />}
                onEdit={(data) => {
                    setEd(data)
                }}
                setEd={setEd}
                rend={rend}
                xwidth={3200}
            />
        </>
    );
}

export default Books;